import { render, staticRenderFns } from "./add-disease.vue?vue&type=template&id=28699853"
import script from "./add-disease.vue?vue&type=script&lang=js"
export * from "./add-disease.vue?vue&type=script&lang=js"
import style0 from "./add-disease.vue?vue&type=style&index=0&id=28699853&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports